import {log, callAdminAjax, updateLoadingSpinner, getTemplate, hasKey, getValue, textToParagraphs, normalizeString, nextFrame, sanitizeWpTitle, createTranslator} from './utils.js';

const $ = window.jQuery;

const t = createTranslator('managePage');
/**
 * Initialize the Manage page.
 */
export function initManagePage() {
    log('Manage page initialized');

    initManagePageUI();

}

function initManagePageUI() {
    log('Manage page UI initialized');

    $(document).on('click', '[data-action="cancelClaim"]', function(e) {
        e.preventDefault();
        const claimId = $(this).data('listing-claim-id');
        log('Cancelling claim: ' + claimId);

        const payload = {
            'listing_claim_id': claimId,
            '_ajax_nonce': window.ironman.gnonce,
        }
        
        // Call the admin ajax function. Use callbacks to handle the response.
        callAdminAjax('deleteListingClaim', payload, 'deleteListingClaim', {
            onSuccess: (response) => {
                $(`[data-label="manageSingleItem"][data-claim-id="${claimId}"]`).remove();
                log('Listing claim deleted successfully.');
            },
            onFail: (error) => {
                log('Error:', error);
                alert(t('couldNotCancelListingClaim'));
            }
        }, 'page-blocking', t('cancellingListingClaimSpinnerMessage'));
    });

}